import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { BankStatementsPDFInstructionsContent } from './bank-statements-pdf-instructions-content';
import { useFetchStateDataIfNull, useQuery } from '../../util/hooks';

export const BankStatementsPDFInstructionsPage = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <BankStatementsPDFInstructionsContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
